<template>
    <div class="starter">
        <b-form>
            <h2>HMRC Starter Checklist</h2>
            <p>
                As a new employee your employer needs the information on this form before your first payday to tell HMRC
                about you and help them use the correct tax code.
            </p>
            <p>
                You must email a copy of your P45 to
                hradmin@trailfinders.com. If you are currently employed you will receive your P45 after your final
                payslip is issued and must email it as soon as you receive it. If you do not have a P45 for the current
                tax year, you do not need to supply any further documents.
            </p>
            <hr/>
            <h3>Employee Statement</h3>
            <!-- statement -->
            <p>
                You need to select only one of the following statements A, B or C
            </p>
            <b-form-group>
                <div class="radio radio-custom">
                    <input id="firstJob"
                           name="statement"
                           v-model="statement"
                           type="radio"
                           value="A: This is my first job since 6 April and I've not been receiving taxable Jobseeker's Allowance, Employment and Support Allowance, taxable Incapacity Benefit, State or Occupational Pension."
                           @change="handleInput('statement', statement)"
                    >
                    <label for="firstJob">A. This is my first job since 6 April and I have not received payments from any of the following – Jobseekers Allowance, Employment and Support Allowance, Incapacity Benefit.</label>
                </div>
                <div class="radio radio-custom">
                    <input id="onlyJob"
                           name="statement"
                           v-model="statement"
                           type="radio"
                           value="B: This is now my only job but since 6 April I've had another job, or received taxable Jobseeker's Allowance, Employment and Support Allowance or taxable Incapacity Benefit. I do not receive a State or Occupational Pension."
                           @change="handleInput('statement', statement)"
                    >
                    <label for="onlyJob">B. Since 6 April I’ve had another job, but do not have a P45 and/or since the 6 April I have received payments from any of the following – Jobseekers Allowance, Employment and Support Allowance, Incapacity Benefit.</label>
                </div>
                <div class="radio radio-custom">
                    <input id="extraJob"
                           name="statement"
                           v-model="statement"
                           type="radio"
                           value="C: As well as my new job, I have another job or receive a State or Occupational pension."
                           @change="handleInput('statement', statement)"
                    >
                    <label for="extraJob">C. I have another job and/or I am in receipt of a State, workplace or private pension.</label>
                </div>
            </b-form-group>
            <hr/>

            <h3>Postgraduate / Student Loans</h3>
            <p>
                For more guidance about repaying go to
                <a href="https://www.gov.uk/repaying-your-student-loan" target="_blank">www.gov.uk/repaying-your-student-loan</a>
            </p>
            <!-- Loan plan -->
            <!-- Plan info -->
            <b-card>
                <p class="mb-2">You have Plan 1 if any of the following apply:</p>
                <ul>
                    <li class="mb-2">You lived in Northern Ireland when you started your course</li>
                    <li>You lived in England or Wales and started your course before 1 September 2012</li>
                </ul>
                <p class="mt-4 mb-2">You have Plan 2 if:</p>
                <ul>
                    <li>You lived in England or Wales and stared your course on or after 1 September 2012</li>
                </ul>
                <p class="mt-4 mb-2">You have Plan 4 if:</p>
                <ul>
                    <li>You lived in Scotland and applied through the Students Award Agency Scotland (SAAS) when you started your course</li>
                </ul>
                <ul>
                    <li class="mb-2">You lived in England and started your postgraduate master’s course on or afer 1 August 2016</li>
                    <li class="mb-2">You lived in Wales and started your postgraduate master’s course on or after 1 August 2017</li>
                    <li>You lived in England or Wales and started your postgraduate doctoral course on of after 1 August 2018</li>
                </ul>
            </b-card>
            <p class="mt-4">
                Do you have one of the Student Loan Plans described above which is not fully repaid?
            </p>
            <b-form-group>
                <div class="radio radio-custom">
                    <input id="studentLoanYes"
                           name="studentLoan"
                           v-model="studentLoan"
                           type="radio"
                           value="Yes: I have a student loan"
                           @change="handleInput('studentLoan', studentLoan)"
                    >
                    <label for="studentLoanYes">Yes</label>
                </div>
                <div class="radio radio-custom">
                    <input id="studentLoanNo"
                           name="studentLoan"
                           v-model="studentLoan"
                           type="radio"
                           value="No: I do not have a student loan"
                           @change="handleInput('studentLoan', studentLoan)"
                    >
                    <label for="studentLoanNo">No</label>
                </div>
            </b-form-group>

            <b-form-group v-if="studentLoan.includes('Yes:')">
                <hr class="mt-0">
                <p class="mt-4">
                    Do any of the following statements apply:
                </p>
                <b-card>

                <ul>
                    <li class="mb-2">You’re still studying on a course that your student loan relates to</li>
                    <li class="mb-2">You completed or left your course after the start of the current tax year, which started on 6 April</li>
                    <li class="mb-2">You’ve already repaid your loan in full</li>
                    <li>You’re paying the Student Loans Company by Direct Debit from your bank to manage your end of loan repayments</li>
                </ul>
                </b-card>
               <div class="radio radio-custom mt-3">
                    <input id="studentLoanQ2StatementsYes"
                           name="studentLoanQ2Statements"
                           v-model="studentLoanQ2Statements"
                           type="radio"
                           value="Yes: One of these statements applies"
                           @change="handleInput('studentLoanQ2Statements', studentLoanQ2Statements)"
                    >
                    <label for="studentLoanQ2StatementsYes">Yes</label>
                </div>
                <div class="radio radio-custom">
                    <input id="studentLoanQ2StatementsNo"
                           name="studentLoanQ2Statements"
                           v-model="studentLoanQ2Statements"
                           type="radio"
                           value="No: None of these statements apply"
                           @change="handleInput('studentLoanQ2Statements', studentLoanQ2Statements)"
                    >
                    <label for="studentLoanQ2StatementsNo">No</label>
                </div>
            </b-form-group>

            <b-form-group v-if="studentLoan.includes('Yes:') && studentLoanQ2Statements.includes('No:')">
                <hr>
                <p>
                    To avoid repaying more than you need to, select the correct student loan / postgraduate loan that you have – use the guidance above to help you. 
                </p>
                <div class="radio radio-custom">
                    <input id="studentLoanTypePlan1"
                           name="studentLoanType"
                           v-model="studentLoanType"
                           type="radio"
                           value="Plan 1"
                           @change="handleInput('studentLoanType', studentLoanType)"
                    >
                    <label for="studentLoanTypePlan1">Plan 1</label>
                </div>
                <div class="radio radio-custom">
                    <input id="studentLoanTypePlan2"
                           name="studentLoanType"
                           v-model="studentLoanType"
                           type="radio"
                           value="Plan 2"
                           @change="handleInput('studentLoanType', studentLoanType)"
                    >
                    <label for="studentLoanTypePlan2">Plan 2</label>
                </div>
                <div class="radio radio-custom">
                    <input id="studentLoanTypePlan4"
                           name="studentLoanType"
                           v-model="studentLoanType"
                           type="radio"
                           value="Plan 4"
                           @change="handleInput('studentLoanType', studentLoanType)"
                    >
                    <label for="studentLoanTypePlan4">Plan 4</label>
                </div>
                <div class="radio radio-custom">
                    <input id="studentLoanTypePlanPostgrad"
                           name="studentLoanType"
                           v-model="studentLoanType"
                           type="radio"
                           value="Postgraduate"
                           @change="handleInput('studentLoanType', studentLoanType)"
                    >
                    <label for="studentLoanTypePlanPostgrad">Postgraduate Loan (England and Wales Only)</label>
                </div>
            </b-form-group>
            <hr/>
        </b-form>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import {required} from 'vuelidate/lib/validators'
import requiredIf from "vuelidate/lib/validators/requiredIf";
import {updateForm, selectPostcode} from '../../helpers/index'

export default {
  computed: {
    ...mapGetters({
      getRecruit: 'authStore/getRecruit'
    }),
    ...mapState({form: state => state.authStore.recruit.onboarding.onboardingForms.starterChecklist}),
  },
  data() {
    return {
      formName: 'starterChecklist',
      postcodeLookup: '',
      postcodeResult: '',
      referer: window.siteVar.referer,
      sex: '',
      statement: '',
      studentLoan: '',
      studentLoanQ2Statements: '',
      studentLoanType: '',
    }
  },
  mounted() {
    this.$v.$touch()
    setTimeout(() => {
        this.sex = this.form.sex
      this.statement = this.form.statement
      this.studentLoan = this.form.studentLoan
      this.studentLoanQ2Statements = this.form.studentLoanQ2Statements
      this.studentLoanType = this.form.studentLoanType
    }, 1000)
  },
  updated() {
    const validationData = {
      section: 'starter',
      status: !this.$v.form.$invalid
    }
    this.updateOnboardingCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      selectAddressAction: 'authStore/selectAddressAction',
      updateOnboardingFormAction: 'authStore/updateOnboardingFormAction',
      currentOnboardingFormAction: 'authStore/currentOnboardingFormAction',
      setRecruitAction: 'authStore/setRecruitAction',
      createNameAction: 'authStore/createNameAction',
      removeNameAction: 'authStore/removeNameAction',
      updateOnboardingCompleteAction: 'authStore/updateOnboardingCompleteAction'
    }),
    handleInput(input, e, nested, array, index, item) {
      this.updateForm(input, e, nested, array, index, item)
    },
    handlePostcode(address, addressOwner, isArray, index, input) {
      this.selectPostcode(address, addressOwner, isArray, index, input)
    },
    addName() {
      this.createNameAction()
    },
    removeName() {
      this.removeNameAction(this.form.firstName.length - 1)
    },
    updateForm,
    selectPostcode
  },
  validations: {
    form: {
      statement: {
        required: required
      },
      studentLoan: {
        required: required
      },
      studentLoanQ2Statements : {
        required: requiredIf((form) => {
            return form.studentLoan.includes("Yes:")
        })
      },
      studentLoanType: {
        required: requiredIf((form) => {
            return form.studentLoan.includes("Yes:") && form.studentLoanQ2Statements.includes("No:")
        })
      }
    }
  }
}
</script>

<style scoped>
.postcode-lookup-input {
    position: relative;
}

.postcode-lookup {
    position: relative;
}

.postcode-dropdown {
    background-color: #fff;
    position: absolute;
    width: 100% !important;
    top: 40px !important;
    max-height: 200px;
    z-index: 10;
    border: 1px solid #4da3ff;
    overflow: auto;
}

@media only screen and (min-width: 992px) {
    .postcode-dropdown {
        right: 0;
        top: 50px;
        width: 70%;
    }
}

.postcode-dropdown ul {
    list-style: none;
    padding: 0;
}

.postcode-dropdown li {
    padding: 10px;
}

.postcode-result {
    transition: all .3s ease;
}

.postcode-result:hover {
    cursor: pointer;
    background-color: #4da3ff;
}

.manual-address {
    display: flex;
    justify-content: center;
}
label small {
    color: #17a2b8;
}
</style>
